import React, { useEffect, useState } from 'react';
import API from '../api';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import './AdminDashboard.css';

const AdminDashboard = () => {
  const { user, logout } = useAuth();
  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [pwCurrent, setPwCurrent] = useState('');
  const [pwNew, setPwNew] = useState('');
  const [pwSaving, setPwSaving] = useState(false);
  const [theme, setTheme] = useState(() => {
    try {
      return localStorage.getItem('adminTheme') || 'dark';
    } catch (_) {
      return 'dark';
    }
  });

  useEffect(() => {
    if (!user) return;
    if (user.role !== 'admin') {
      navigate('/');
      return;
    }
    loadDashboardData();
  }, [user, navigate]);

  const loadDashboardData = async () => {
    try {
      setLoading(true);
      setError(null);
      const summaryRes = await API.get('/admin/summary');
      setSummary(summaryRes.data);
    } catch (error) {
      console.error('Error loading dashboard data:', error);
      setError('Failed to load dashboard data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    try {
      localStorage.setItem('adminTheme', theme);
    } catch (_) {}
  }, [theme]);

  if (!user) return null;

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="spinner"></div>
        <p>Loading admin dashboard...</p>
      </div>
    );
  }

  return (
    <div className={`admin-dashboard ${theme === 'light' ? 'light' : 'dark'}`}>
      {error && (
        <div className="error-banner">
          <span>⚠️ {error}</span>
          <button onClick={() => setError(null)}>✕</button>
        </div>
      )}

      <div className="dashboard-content">
        <div className="admin-topbar">
          <h1 className="admin-title">Admin Dashboard</h1>
          <div className="admin-actions">
            <button
              className="theme-toggle"
              onClick={() => setTheme(theme === 'light' ? 'dark' : 'light')}
              aria-label="Toggle theme"
            >
              {theme === 'light' ? '🌙 Dark' : '☀️ Light'}
            </button>
            <button
              className="home-button"
              onClick={() => {
                navigate('/');
              }}
            >
              Home
            </button>
            <button
              className="logout-button"
              onClick={() => {
                logout();
                navigate('/admin-login');
              }}
            >
              Logout
            </button>
          </div>
        </div>
        {/* Statistics Section */}
        <div className="stats-section">
          <h2>Dashboard Overview</h2>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-icon">👥</div>
              <div className="stat-content">
                <h3>{summary?.usersCount || 0}</h3>
                <p>Total Users</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📝</div>
              <div className="stat-content">
                <h3>{summary?.postsCount || 0}</h3>
                <p>Total Posts</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">🔒</div>
              <div className="stat-content">
                <h3>1</h3>
                <p>Admin User</p>
              </div>
            </div>
            <div className="stat-card">
              <div className="stat-icon">📅</div>
              <div className="stat-content">
                <h3>{new Date().toLocaleDateString()}</h3>
                <p>Today's Date</p>
              </div>
            </div>
          </div>
        </div>

        {/* Project Management Section removed */}

        {/* Password Change Section */}
        <div className="password-section">
          <h2>Change Your Password</h2>
          <div className="password-form">
            <input 
              type="password" 
              placeholder="Current password" 
              value={pwCurrent} 
              onChange={e => setPwCurrent(e.target.value)}
              className="form-input"
            />
            <input 
              type="password" 
              placeholder="New password (min 6 chars)" 
              value={pwNew} 
              onChange={e => setPwNew(e.target.value)}
              className="form-input"
            />
            <button
              className="btn-primary"
              disabled={pwSaving || !pwCurrent || !pwNew}
              onClick={async () => {
                try {
                  setPwSaving(true);
                  await API.put('/users/password', { 
                    currentPassword: pwCurrent, 
                    newPassword: pwNew 
                  });
                  setPwCurrent(''); 
                  setPwNew('');
                  alert('Password updated successfully!');
                } catch (e) {
                  alert(e?.response?.data?.message || 'Update failed');
                } finally {
                  setPwSaving(false);
                }
              }}
            >
              {pwSaving ? 'Updating...' : 'Update Password'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;


